import React, { Component } from 'react';
import { forEach } from 'lodash-es';
import { DealerCarouselWithDescription } from 'site-modules/dealerships/components/dealer-carousel-with-description/dealer-carousel-with-description';
import { DealerCarouselSlide } from 'site-modules/dealerships/components/dealer-carousel-slide/dealer-carousel-slide';
import { getImageUrl } from 'client/utils/image-helpers';
import { getTagsFromPhotosArray, groupPhotosByTag } from 'client/site-modules/dealerships/utils/dealer-photos';
import { getDealerPageBreadcrumbs } from 'site-modules/dealerships/utils/breadcrumbs';
import Container from 'reactstrap/lib/Container';
import { Breadcrumbs } from 'site-modules/shared/components/breadcrumbs/breadcrumbs';
import { DealerInfoEntities } from 'client/data/models/dealer-info';
import { DealerHeaderTitle } from 'site-modules/dealerships/components/dealer-header-title/dealer-header-title';

import './dealer-photos-carousel.scss';

export class DealerPhotosCarouselUI extends Component {
  state = {
    currentSlide: 0,
  };

  renderSlides = groupedPhotos => {
    const { id, name, fiveStarDealerAward } = this.props.dealerInfo;
    const slidesByCategory = {};
    forEach(groupedPhotos, (photosGroup, photosGroupName) => {
      slidesByCategory[photosGroupName] = photosGroup.map((photoData, index) => {
        const key = `photo_${photosGroupName}_${index}}`;
        return (
          <div key={key} className="slide" data-index={index}>
            <DealerCarouselSlide
              slideNumber={index}
              dealerId={id}
              photoUrl={photoData.adjustedPhotoUrl || getImageUrl(photoData.photoUrl)}
              dealerName={name}
              fiveStarDealerAward={fiveStarDealerAward}
              isDefaultSlide={!!photoData.isDefaultSlide}
            />
          </div>
        );
      });
    });
    return slidesByCategory;
  };

  renderCarousel() {
    const { id, showroomPhotos, name, fiveStarDealerAward, logoUrl } = this.props.dealerInfo;
    const hasShowroomPhotos = showroomPhotos && !!showroomPhotos.length;
    let tagList;
    let photosByTag;
    let slidesByTag;
    if (hasShowroomPhotos) {
      tagList = getTagsFromPhotosArray(showroomPhotos);
      photosByTag = groupPhotosByTag({ showroomPhotos, logoUrl, tagList });
      slidesByTag = this.renderSlides(photosByTag);
    }
    return hasShowroomPhotos ? (
      <DealerCarouselWithDescription
        photosByCategory={photosByTag}
        slidesByCategory={slidesByTag}
        tagList={tagList}
        dealerId={id}
      />
    ) : (
      <DealerHeaderTitle dealerName={name} fiveStarDealerAward={fiveStarDealerAward} />
    );
  }

  render() {
    const breadcrumbs = getDealerPageBreadcrumbs(this.props.dealerInfo);
    return (
      <div className="dealer-photos-carousel pos-r standard-spacing-first h-100" id="edm-entry-dealer-photos">
        {this.renderCarousel()}
        {!!breadcrumbs && (
          <div className="breadcrumbs-wrapper pos-a w-100">
            <Container>
              <Breadcrumbs className="pos-a p-0" data={breadcrumbs} />
            </Container>
          </div>
        )}
      </div>
    );
  }
}

DealerPhotosCarouselUI.propTypes = {
  dealerInfo: DealerInfoEntities.DealerInfo,
};

DealerPhotosCarouselUI.defaultProps = {
  dealerInfo: {},
};
